import { useInsightV2Query } from "../generated/graphql"
import { useGraphQLClient } from "./useGraphQLClient"

export const useInsight = (pk: number) => {
  const graphQLClient = useGraphQLClient()
  // TODO: use the correct schema_version query
  // for now all of these will be v2
  const { data: insightData } = useInsightV2Query(graphQLClient, {
    id: pk,
  })

  return insightData
}
